import React from "react";
import "./Home.scss";
import Banner from "./HomeComponets/Banner/Banner.jsx";
import UseCases from "../../Component/UseCases/UseCases.jsx";
import AboutUs from "../../Component/AboutUs/AboutUs.jsx";
import Features from "../../Component/Features/Features";
import Token from "../../Component/Token/Token";
import Buytoken from "../../Component/Buytoken/Buytoken";
import CryptoCard from "../../Component/CryptoCard/CryptoCard";
import PathAhead from "../../Component/pathAhead/PathAhead";
import Team from "../../Component/Team/Team";
import DownloadUniwallet from "../../Component/downloadUniwallet/DownloadUniwallet";
import Faqs from "../../Component/Faqs/Faqs";
import UniPay from "../../Component/UniPay/UniPay";
import GetInTouch from "../../Component/GetInTouch/GetInTouch";
import { Element } from 'react-scroll'
function Home() {
  return (
    <div className="home">
      <Element name="home"><Banner /></Element>
      <Element name="about"><AboutUs /></Element>
      <Element name="feature"><Features /></Element>
      <Element name="token"><Token /></Element>
      <UseCases />
      <Buytoken />
      <Element name="card"><CryptoCard /></Element>
      <Element name="roadmap"><PathAhead /></Element>
      <Team />
      <DownloadUniwallet />
      <Element name="faq"><Faqs /></Element>
      <Element name="contact"><GetInTouch /></Element>
      <UniPay />
    </div>
  );
}

export default Home;
